import { render, staticRenderFns } from "./RemapFlag.vue?vue&type=template&id=556bac72"
import script from "./RemapFlag.vue?vue&type=script&lang=js"
export * from "./RemapFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports